<template>
    <footer class="footer">
        <nav class="footer__linksList">
            <ul>
                <li class="footer__linksItem">
                    <a :href="$t('footer:nav.aboutUBS.url')" target="_blank" rel="noopener" @click="onLinkClicked">{{ $t('footer:nav.aboutUBS.label') }}</a>
                </li>
                <li class="footer__linksItem">
                    <a :href="$t('footer:nav.termsOfUse.url')" target="_blank" rel="noopener" @click="onLinkClicked">{{ $t('footer:nav.termsOfUse.label') }}</a>
                </li>
                <li class="footer__linksItem">
                    <a :href="$t('footer:nav.privacy.url')" target="_blank" rel="noopener" @click="onLinkClicked">{{ $t('footer:nav.privacy.label') }}</a>
                </li>
                <li class="footer__linksItem">
                    <a :href="$t('footer:nav.reportEmail.url')" target="_blank" rel="noopener" @click="onLinkClicked">{{ $t('footer:nav.reportEmail.label') }}</a>
                </li>
                <li class="footer__linksItem">
                    <a :href="$t('footer:nav.legal.url')" target="_blank" rel="noopener" @click="onLinkClicked">{{ $t('footer:nav.legal.label') }}</a>
                </li>
                <li class="footer__linksItem">
                    <a :href="$t('footer:nav.cookies.url')" target="_blank" rel="noopener" @click.prevent="togglecookiemodal($event)">{{ $t('footer:nav.cookies.label') }}</a>
                </li>
            </ul>
        </nav>
        <div class="footer__disclaimer">
            {{ $t('footer:disclaimer') }}
        </div>
         <div class="footer__copyright">
             {{ $t('footer:copyright') }}
        </div>
    </footer>
</template>
<script>
import adobeTracking from '@/mixins/adobeTracking'
export default {
    name: 'Footer',
    mixins: [
        adobeTracking
    ],
    methods: {
        onLinkClicked(e) {
            console.log('here' + e)
            this.trackCTAClick({
                CTAName: e.target.innerText,
                CTALink: e.target.href
            })
        },
        togglecookiemodal(e) {
            const privacytButton = document.querySelector('[data-nn-init="privacysettings"]')
            privacytButton.click()
            this.onLinkClicked(e)
        }
    }
}
</script>
